import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChart1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chart-1, statistics, flipchart, presentation, graph 2"} maskId="square-filled-radius-0-stroke-1-IconChart1"><path fillRule="evenodd" clipRule="evenodd" d="M2 19V3H22V19H15.6629L16.6181 22.3434L15.6566 22.6181L14.6228 19H9.37715L8.3434 22.6181L7.38188 22.3434L8.33713 19H2ZM8.25 12.25H7.25V14.75H8.25V12.25ZM12.5 7.25V14.75H11.5V7.25H12.5ZM16.75 10.25H15.75V14.75H16.75V10.25Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChart1;
